function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBtnMenuMy = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  "data-name": "\\uC0AC\\uAC01\\uD615 186",
  style: {
    fill: "none"
  },
  d: "M0 0h28v28H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.25 10.083h-4.583a2.753 2.753 0 0 0-2.75 2.75v6.417a2.753 2.753 0 0 0 2.75 2.75h4.583A2.753 2.753 0 0 0 22 19.25v-6.417a2.753 2.753 0 0 0-2.75-2.75zm-.917 8.25h-2.75a.917.917 0 1 1 0-1.833h2.75a.917.917 0 1 1 0 1.833zm0-3.669h-2.75a.917.917 0 1 1 0-1.833h2.75a.917.917 0 1 1 0 1.833zM2.75 5.5a5.5 5.5 0 1 1 5.5 5.5 5.506 5.506 0 0 1-5.5-5.5zM11.024 22H.917A.924.924 0 0 1 0 21.068a8.259 8.259 0 0 1 8.25-8.234 8.223 8.223 0 0 1 1.833.213v6.2A4.536 4.536 0 0 0 11.024 22z",
  transform: "translate(4 3)",
  style: {
    fill: "#fff"
  }
}));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBtnMenuMy);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "bf0086650fa6f3b3378b8828ec217513.svg";